import React from 'react';
import { MobileContainer } from '@components/organism/MobileContainer';
import { EditVehicleData } from '@components/molecules/EditVehicleData';

export function EditVehicle() {
    return (
        <MobileContainer>
            <EditVehicleData />
        </MobileContainer>
    );
}
